const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/actions/sublimd.ts';
import { kisapiActionTypes } from '@cistec/common_web/defs/actionTypes';
import { createPatapiCall, HttpMethod } from 'App/utils/fetchUtils';

export const REQUEST_ACTION_TYPES_SUBLIMD = kisapiActionTypes('PATAPP_SUBLIMD');

export function actionLoadSublimdIFrameUrl(termNr: string) {
    const endpoint = `toberenamed/sublimdUrl/${termNr}`;
    const meta = { termNr };
    return createPatapiCall(REQUEST_ACTION_TYPES_SUBLIMD, endpoint, HttpMethod.GET, meta);
}
